import axiosInstance from '../axiosConfigCMS';

export default {
  async getContent() {
    const response = await axiosInstance.get('/menu-shop-banner');
    return response.data;
  },
};
